import AjaxClass from './Validation/ajaxClass';
import FormValidate from './Validation/formValidateClass';
import MessageHandler from './Validation/messageHandler';

export default function career() {
    $("#career-form").on('submit', function (e) {
        e.preventDefault();

        const Loader = document.getElementById("loading-forms");
        const confirmationModal = document.getElementById('confirmation-modal');
        const confirmationMessage = document.getElementById('confirmation-message');
        const confirmButton = document.getElementById('confirm-button');
        const cancelButton = document.getElementById('cancel-button');

        let form = $(this);
        let fields = form.serializeArray();

        let resume = { 'name': 'resume', 'value': $("#resume")[0].files[0] };
        fields.push(resume);

        // let contract_type = {
        //     name: "contract_type",
        //     value: document.getElementById("tipoContratacao").value,
        // };

        // let work_mode = {
        //     name: "work_mode",
        //     value: document.getElementById("modoTrabalho").value,
        // };

        let unit = {
            name: "unit",
            value: document.getElementById("unidade").value,
        };

        /*
        // Obtendo o título e valor da vaga
        const vagaSelect = document.getElementById("vaga");
        const vagaSelecionadaTitulo = vagaSelect.options[vagaSelect.selectedIndex].text;
        const vagaSelecionadaValue = vagaSelect.value;

        let oportunity = {
            name: "oportunity",
            value: vagaSelecionadaValue, // Ainda armazena o valor numérico
        };
        */

        // fields.splice(fields.length - 1, 0, contract_type);
        // fields.splice(fields.length - 1, 0, work_mode);
        fields.splice(fields.length - 1, 0, unit);
        /*fields.splice(fields.length - 1, 0, oportunity);*/

        let validation = new FormValidate(fields);
        const modalSuccess = document.getElementById('success-message-forms');
        const modalSuccessDescription = document.querySelector('#success-message-forms .description');
        const modalError = document.getElementById('error-message-forms');
        const modalDescription = document.querySelector('#error-message-forms .description');

        validation.validateAll(fields);
        let error = validation.hasError();

        MessageHandler.removeAllFormFailMessages();
        let terms = $("#checkbox").prop('checked') == true;
        if (!error && !terms) {
            error = true;
            const id = $("#checkbox").attr('idError');
            MessageHandler.showFailMessage(id, true);
            return false;
        }

        if (error) {
            let errorMessageId = validation.getErrorId();
            MessageHandler.showFailMessage(errorMessageId, true);
            $("#confirm-button").removeAttr('disabled');
            return false;
        }

        // Exibir Modal de Confirmação
        // confirmationMessage.innerHTML = `Você tem certeza de que deseja se candidatar para a vaga <b>${vagaSelecionadaTitulo}</b><br> na unidade <b>${document.getElementById("unidade").value}</b>?`;
        // confirmationModal.classList.add("open-modal");

        // Confirmação pelo Modal
        // confirmButton.onclick = function () {
            confirmationModal.classList.remove("open-modal");
            Loader.classList.add("open-modal");

            if ($(this).attr('disabled') == 'disabled') {
                return false;
            }
            $(this).attr('disabled', 'disabled');

            let type = 'POST';
            let url = form.attr('action');
            let dataType = 'json';

            let formData = new FormData();
            fields.forEach(obj => {
                formData.append(obj.name, obj.value);
            });

            class Newsletter extends AjaxClass {
                successFunction(data, form) {
                    Loader.classList.remove("open-modal");
                    if (data.status == true) {
                        $('#career-form').trigger("reset");
                        $("#career-form").removeAttr('disabled');
                        $("#confirm-button").removeAttr('disabled');
                        modalSuccess.classList.add("open-modal");
                        modalSuccessDescription.innerHTML = data.txt;
                    } else {
                        modalDescription.innerHTML = data.txt;
                        modalError.classList.add("open-modal");
                        $("#career-form").removeAttr('disabled');
                        $("#confirm-button").removeAttr('disabled');
                    }
                };
                errorFunction(xhr, textStatus, errorThrown) {
                    Loader.classList.remove("open-modal");
                    modalDescription.innerHTML = "Ocorreu um erro. Tente novamente mais tarde.";
                    modalError.classList.add("open-modal");
                    $("#career-form").removeAttr('disabled');
                    $("#confirm-button").removeAttr('disabled');
                };
            }
            let ajax = new Newsletter(form, type, url, dataType, formData);
            ajax.send();
        // };

        // Cancelar no Modal
        cancelButton.onclick = function () {
            confirmationModal.classList.remove("open-modal");
        };

        return false;
    });
}
